import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { authReducers, AuthState } from './auth/state/auth.reducer';
import { routerReducer } from '@ngrx/router-store';
import { RouterStateUrl } from './router/state/router.reducer';

export interface AppState {
  auth: AuthState;
  router: RouterStateUrl;
}

export const reducers: ActionReducerMap<AppState | any> = {
  auth: authReducers,
  router: routerReducer,
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function debugReducers(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) =>
     reducer(state, action)
  ;
}

export const metaReducers: MetaReducer<any>[] = [debugReducers];
